import { Constants } from "@socialcoach/services";
import axios from "./AxiosClient";

const PW_LINK_SERVICE = `${Constants.API_URL}/bedrock/admin/password_links`;

export interface PWLinkResponse {
  link: string;
}

export interface PWIntentResponse {
  status: string;
  error?: string;
}

export class AdminServices {
  static async registerPasswordLinkIntent(email: string): Promise<PWIntentResponse> {
    const { data } = await axios.post<PWIntentResponse>(`${PW_LINK_SERVICE}/register_intent`, { email });
    return data as PWIntentResponse;
  }

  static async verifyPasswordLinkIntent(email: string, token: string): Promise<PWLinkResponse> {
    const { data } = await axios.post<PWLinkResponse>(`${PW_LINK_SERVICE}/verify_intent`, { email, token });
    return data as PWLinkResponse;
  }
}
